import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-panel',
  templateUrl: './menu-panel.component.html',
  styleUrls: ['../../app.component.css', './menu-panel.component.css']
})

export class MenuPanelComponent { }
